import { Component, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { DatePipe, CurrencyPipe } from "@angular/common";
import { firstValueFrom, merge, of as observableOf } from "rxjs";
import { Subscription } from "rxjs";
import { map, startWith, switchMap } from "rxjs/operators";
import { AbstractSellerComponent } from "../abstract/seller.component";
import { EntityBase } from "../../entity/EntityBase";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort, MatSortHeader } from "@angular/material/sort";
import { Pair } from "../../obj/Pair";
import { SellerContract } from "../../entity/SellerContract";
import { Utility } from "../../entity/Utility";
import { SellOffer } from "../../entity/SellOffer";
import { KilowantContract } from "../../entity/KilowantContract";
import { AuthService } from "../../service/auth.service";
import { AnalyticsService } from "../../service/analytics.service";
import { GeneralService } from "../../service/general.service";
import { User } from "../../entity/User";
import { ConfirmationDialog } from "../incs/confirmation-dialog.component";
import { SellerSellOfferAddUpdateDialog } from "../incs/seller-sell-offer-add-update-dialog.component";
import { RateClass } from "../../entity/RateClass";
import { LoadZone } from "../../entity/LoadZone";
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from "@angular/material/table";
import { MatIcon } from "@angular/material/icon";
   
@Component({
    selector: "kilowant-seller-sell-offers",
    templateUrl: "../../../html/seller/seller-sell-offers.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, MatIcon, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator, CurrencyPipe, DatePipe]
})

export class SellerHomeSellOfferComponent extends AbstractSellerComponent {
    @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: false }) sort: MatSort;
    dialogRef: MatDialogRef<any> = null!;

    listSellOffersSubscription: Subscription | null;
  displayedColumns: string[] = ["#", "UtilityName", "LoadZone", "RateClass", "StartingOn", "TermPeriod", "TargetPrice", "Fee", "Price", "ValidUntil", "ContractTerms", "CreatedBy","DateEntered","Action"];
    total: number = 0;
    
    user: User = new User();
    sellOfferList: SellOffer[] = null!;
    contracts: KilowantContract[] = null!;

    editedRecord: number = -1;
    sellOffer: SellOffer = null!;
    utilities: Utility[] = null!;
    rateClasses: RateClass[] = [];
    loadZones: LoadZone[] = [];
    terms: number[] = [6,12,18,24,36];
    sellerContracts: SellerContract[] = [];
    validDate: string = null!;
    startDate: string = null!;

    showError: boolean = false;
    error: string = "";
    errors: string[] = [];

    constructor(
        router: Router,
        route: ActivatedRoute,
        authService: AuthService,
        analyticsService: AnalyticsService,
        generalService: GeneralService,
        private datepipe: DatePipe,
        dialog: MatDialog
    ) { super(router, route, dialog, authService, analyticsService, generalService); }

    ngOnInit(): void {
    }

    ngAfterViewInit() {
        this._loadSellOffers();
    }
   
    _loadSellOffers(): void {
        if (this.listSellOffersSubscription!=null) {
           this.listSellOffersSubscription.unsubscribe();
        }
        this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
        this.listSellOffersSubscription = merge(this.sort.sortChange, this.paginator.page)
          .pipe(
           startWith({}),
           switchMap(() => {
            return this.generalService.getSellOfferList(this.total, this.paginator.pageIndex, this.sort.active, (this.sort.direction=="desc"));
          }),
          map(data => {
            if (data === null) {
              return [];
            }
            this.total = data.key;
            return data.value;
        }),
        )
            .subscribe(data => { this.sellOfferList = data; this.refreshView() });
    }

    openAddUpdatePopup(): void {
      this.dialogRef = this.dialog.open(SellerSellOfferAddUpdateDialog, {
         disableClose: false
         ,panelClass: "card-popup"
      });
      this.dialogRef.afterClosed().subscribe(result => {
           this._loadSellOffers();
           this.dialogRef = null!;
       });
    }

    openFTPDetailsPopup(): void {
        firstValueFrom(this.generalService.getFTPData()).then(data => {
            if (data == null) {
                this.openResultsPopup("FTP Details", "FTP was not set for your account. Please, contact support.", null);
            } else {
                this.openResultsPopup("FTP Details", "FTP Address: ftp://ftp.kilowant.com<br/>Username: " + data.key + "<br/>Password: " + data.value, null);
            }
        }
        );
    }    

    markSellOfferNotNew(sellOffer: SellOffer): void {
        if (sellOffer.isNewRecord) {
           this.generalService.markSellOfferViewed(sellOffer)
               .subscribe({
                   next: (res: any) => {
                       if (res) {
                           this._loadSellOffers();
                       }
                   },
                   error: (err: any) => { }
               });
       }
    }
    
    deleteSellOffer(sellOffer: SellOffer): void {
      this.dialogRef = this.dialog.open(ConfirmationDialog, {
         disableClose: false
         ,panelClass: "card-popup"
      });
      this.dialogRef.componentInstance.confirmMessage = "Are you sure you want to delete this sell now proposal?"

      this.dialogRef.afterClosed().subscribe(result => {
        if(result) {
          this.generalService.deleteSellOffer(sellOffer.id)
              .subscribe(
                  {
                      next: (res: any) => {
                          if (res) {
                              this._loadSellOffers();
                          }
                      },
                      error: (err: any) => { }
                  });       
        }
        this.dialogRef = null!;
       });
    }

    copySellOffer(sellOffer: SellOffer): void {
      this.dialogRef = this.dialog.open(SellerSellOfferAddUpdateDialog, {
         disableClose: false
         ,panelClass: "card-popup"
      });
      var newSellOffer = new SellOffer(sellOffer);
      this.dialogRef.componentInstance.setSellOffer(newSellOffer);
      this.dialogRef.afterClosed().subscribe(result => {
           this._loadSellOffers();
           this.dialogRef = null!;
       });
    }

    includes(list: EntityBase[], item: EntityBase): boolean {
        return (EntityBase.includes(list, item));
    }

    resetError(field: string): void {
       if (this.errors.includes(field)) {
           this.errors.splice(this.errors.indexOf(field), 1);
       }
       this.showError = false;
       for (var i=0; i<this.errors.length; i++) {
           if (this.errors.length>0) {
              this.showError = true;
              break;
           }
       }
    }
    compareFn(c1: EntityBase, c2: EntityBase): boolean {
        return c1 && c2 ? c1.id === c2.id : c1 === c2;
    }
    compareKeyFn(c1: Pair, c2: Pair): boolean {
        return c1 && c2 ? c1.key === c2.key : c1 === c2;
    }

    ngOnDestroy(){
        if (this.listSellOffersSubscription!=null) {
           this.listSellOffersSubscription.unsubscribe();
        }
    }
}
